import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "px-10 sm:px-16 md:px-24 lg:px-32 xl:px-36 absolute w-full bottom-0 left-0" }
const _hoisted_2 = { class: "grid grid-cols-1 sm:grid-cols-3" }
const _hoisted_3 = { class: "text-16 text-dark-blue font-bold mb-5" }
const _hoisted_4 = /*#__PURE__*/_createVNode("hr", { class: "w-full border-black" }, null, -1)
const _hoisted_5 = { class: "text-10 text-center py-5 font-thin text-modal-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.footerMenu, (menu, index) => {
        return (_openBlock(), _createBlock("div", {
          key: index,
          class: "my-8 col-span-1 py-8 px-8"
        }, [
          _createVNode("ul", null, [
            _createVNode("li", _hoisted_3, _toDisplayString(menu.title), 1),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(menu.links, (menuItem, itemIndex) => {
              return (_openBlock(), _createBlock("li", {
                key: itemIndex,
                class: "mb-1"
              }, [
                _createVNode("a", {
                  class: "text-14 text-modal-body font-thin hover:text-btn-primary",
                  target: "blank",
                  href: menuItem.href
                }, _toDisplayString(menuItem.name), 9, ["href"])
              ]))
            }), 128))
          ])
        ]))
      }), 128))
    ]),
    _hoisted_4,
    _createVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('dashboard.copyright')) + " " + _toDisplayString(new Date().getFullYear()) + " © " + _toDisplayString(_ctx.$t('dashboard.copyright-brand')), 1)
  ]))
}